export const partnersListSelector = state => state.partners.partners.items;
